import { render, staticRenderFns } from "./AddNewButton.vue?vue&type=template&id=6a649bf3&scoped=true"
import script from "./AddNewButton.vue?vue&type=script&lang=js"
export * from "./AddNewButton.vue?vue&type=script&lang=js"
import style0 from "./AddNewButton.vue?vue&type=style&index=0&id=6a649bf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a649bf3",
  null
  
)

export default component.exports